<template>
  <el-dialog
    :visible.sync="userCenterShow"
    @close="handleClose"
    show-close
    width="450px"
    :close-on-click-modal="false"
  >
    <ul class="title">
      <li :class="{ active: activeTab === 'info' }" @click="tabActive('info')">{{ $t('nav[0]') }}</li>|
      <li
        :class="{ active: activeTab === 'password' }"
        @click="tabActive('password')"
      >{{ $t('nav[1]') }}</li>
    </ul>
    <ul v-if="userInfo">
      <li v-show="activeTab === 'info' ">
        <div class="avatar-box">
          <div
            class="id"
            v-if="userInfo && userInfo.role_id !== 40001"
          >{{ $store.getters.roleName }}</div>
          <div class="avatar" :style="{ backgroundImage: `url(${userInfo.avatar_url})` }"></div>
        </div>
        <el-form class="form" label-width="100px">
          <el-form-item :label="`${$ct('name')}:`">{{userInfo.real_name}}</el-form-item>
          <el-form-item :label="`${$ct('email')}:`">
            <span v-if="userInfo.mail">{{ userInfo.mail }}</span>
            <span class="bind-tips" v-else @click="modifyEmail">{{ $t('click') }}</span>
            <el-input v-if="showModify" v-model.trim="email" class="modify-email">
              <el-button @click="saveEmail" slot="append">{{ $ct('ok') }}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item v-if="userInfo.mail">
            <span class="modify-email" @click="modifyEmail">{{ $t('modify') }}</span>
          </el-form-item>
        </el-form>
      </li>
      <li v-show="activeTab === 'password'" class="password-pannel">
        <el-button @click="sendEmail">{{ $t('send') }}</el-button>
      </li>
    </ul>
  </el-dialog>
</template>
<script>
import { patch, post } from '@/utils/ajax'
import { isMail } from '@/utils/utils'
import { mapState } from 'vuex'
export default {
  name: 'UserInfo',
  data() {
    return {
      activeTab: 'info',
      showModify: false,
      email: ''
    }
  },
  computed: {
    ...mapState(['userInfo']),
    userCenterShow: {
      get() {
        return this.$store.state.userCenterShow
      },
      set(value) {
        return this.$store.commit('USERCENTERSHOW', value)
      }
    }
  },
  methods: {
    tabActive(type) {
      if (type === 'password' && !this.userInfo.mail) return this.$message.warning(this.$t('tips'))
      this.activeTab = type
      this.showModify = false
    },
    modifyEmail() {
      this.email = this.userInfo.mail || ''
      this.showModify = true
    },
    async saveEmail() {
      if (!isMail(this.email)) return this.$message.error(this.$ct('messages.emailInvaild'))
      await patch('/edu/zone/users/updateEmail', {
        email: this.email
      })
      this.$message.success(this.$ct('csuccess'))
      this.showModify = false
      this.$store.dispatch('getUserInfo', { cache: false })
    },
    reset() {
      this.showModify = false
      this.activeTab = 'info'
    },
    handleClose() {
      this.reset()
    },
    async sendEmail() {
      await post('/edu/zone/reset/password/email')
      this.$message.success(this.$t('success'))
    }
  },
  destroyed() {
    this.reset()
  }
}
</script>
<style lang="scss" scoped>
.id {
  width: 80px;
  height: 26px;
  border-radius: 4px;
  background: #fd8200;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -15px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 10px #fd8200;
  border: 2px #fff solid;
  font-size: 12px;
}
.title {
  display: flex;
  width: 80%;
  margin: -20px auto 20px auto;
  border-bottom: 1px #ccc solid;
  align-items: center;
  li {
    text-align: center;
    width: 50%;
    cursor: pointer;
    .lang-en & {
      font-size: 12px;
    }
  }
  .active {
    font-size: 14px;
    border-bottom: 3px solid #399aca;
    color: #399aca;
    .lang-en & {
      font-size: 14px;
    }
  }
}
.avatar-box {
  position: relative;
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: center / cover;
  border: 1px solid #ccc;
}
.bind-tips {
  color: red;
}
.modify-email {
  cursor: pointer;
  color: red;
  position: absolute;
  top: 0;
  left: 0;
  /deep/ {
    .el-button {
      border: 0;
    }
  }
}
.password-pannel {
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<i18n lang="yaml">
en:
  modify: Modify email
  click: Bind email
  input: Input new email
  send: Send password reset e-mail
  nav:
    - Personal information
    - Change password
  unbind: Unbound
  tips: Please bind the mailbox first
  success: Message has been sent
zh-CN:
  modify: 修改邮箱
  click: 请点击绑定
  input: 请输入新邮箱
  send: 发送重置密码邮件
  nav:
    - 个人资料
    - 修改密码
  unbind: 未绑定
  tips: 请先绑定邮箱
  success: 邮件已发送，请注意查收
zh-TW:
  modify: 修改郵箱
  click: 請點擊綁定
  input: 請輸入新郵箱
  send: 發送重置密碼郵件
  nav:
    - 個人資料
    - 修改密碼
  unbind: 未綁定
  tips: 請先綁定郵箱
  success: 郵件已發送，請注意查收
it:
  modify: Modifica e-mail
  click: Fai clic per associare l'e-mail
  input: Inserisci una nuova email
  send: Invia e-mail di reimpostazione password
  nav:
    - Informazioni personale
    - Cambia password
  unbind: Unbound
  tips: Si prega di associare prima l'e-mail
  success: Il messaggio è stato inviato
id:
  modify: Ubah E-mail
  click: Hubungkan E-mail
  input: Masukkan E-mail Baru
  send: Kirim E-mail atur ulang kata sandi
  nav:
    - Informasi Pribadi
    - Ubah Kata Sandi
  unbind: Putuskan
  tips: Silahkan hubungkan E-mail terlebih dahulu
  success: Pesan telah berhasil dikirim
</i18n>
